const __WEBPACK_NAMESPACE_OBJECT__ = require("live/components/widget/config/forms/tooltip");